export default {
  currencySign: '€',
}